import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import { FindClassificationsOutput, FindClassificationsParams } from './classifications.types';

const PATH = 'classifications';

export const findClassifications = (params: FindClassificationsParams, signal?: AbortSignal) =>
  restApi.get<FindClassificationsOutput>(PATH, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const deleteClassification = (id: string) => restApi.delete(`${PATH}/${id}`);
